import React from "react";
import "./TrialPeriodExpiredModal.scss";

import TrialPeriodExpired from "static/icons/trial-period-expired.svg"
import UniversalButton from "../../uiComponents/UniversalButton";
import TrialMessageModal from "components/modals/TrialMessageModal";
import { useContext } from "react";
import { ModalContext } from "components/ModalContext";

const TrialPeriodExpiredModal = () => {
    const { handleModal } = useContext(ModalContext);

    const onActionClick = () => {
        handleModal(<TrialMessageModal />);
    }

    return (
        <div className="trial-period-expired">
            <img
                className="trial-period-expired__img"
                src={TrialPeriodExpired}
            />

            <div className="trial-period-expired__content">
                <p className="trial-period-expired__content-title">
                    Trial period has expired!
                </p>

                <p className="trial-period-expired__content-text">
                    Don't worry, your work hasn't been lost.<br /><br />
                    Contact us to continue using BIMSearch.<br /><br />
                </p>

                <div className="trial-period-expired__button-container">
                    <UniversalButton
                        label="Get in touch!"
                        size="lg"
                        labelColor="white"
                        labelHoverColor="white"
                        backgroundColor="orange"
                        backgroundHoverColor="orange-light"
                        onClick={onActionClick}
                    />
                </div>
            </div>
        </div>
    );
};

export default TrialPeriodExpiredModal;
